<template>
    <div class="questionnaire-multi-step-form">
      <NavigationBackButton />
      <div class="p-2 px-5 ">
        <template v-if="safe_form_config.length">
          <div
            v-for="(form, fIdx) in safe_form_config"
            :key="`form-${fIdx}`"
            class="questionnaire-form-wrapper"
            :class="{
              prev: current_form_index > fIdx,
              active: current_form_index === fIdx,
              next: current_form_index < fIdx
            }"
          >
            <div class=" mt-0 " v-if="form">
              <div class="questionnaire-form-header text-x mb-3 mt-2" v-if="form.form_name">
                {{ form.form_name }}
              </div>

              <div v-if="form.sections && form.sections.length">
                <div
                  v-for="(section, sIdx) in form.sections"
                  :key="`section-${sIdx}`"
                  class="glassy-bg border-0 rounded-lg mb-2 p-3 shadow"
                >
                  <div
                    class="section-header mt-3 text-xs d-flex justify-content-between align-items-center"
                    @click="toggleSection(fIdx, sIdx)"
                    style="cursor: pointer;"
                  >
                    <div class="d-flex align-items-center gap-2 text-x fw-bold">
                      {{ section.name }}
                      <span
                        :class="section.is_verified ? 'text-success' : 'text-danger'"
                        class="fs-5 fw-bold"
                      >
                        {{ section.is_verified ? '✓' : '!' }}
                      </span>
                    </div>
                    <i
                      :class="isSectionOpen(fIdx, sIdx)
                        ? 'fa-solid fa-chevron-up'
                        : 'fa-solid fa-chevron-down'"
                    ></i>
                  </div>

                  <hr class="mt-0 fw-bold border table-border-color" />

                  <div
                    class="form-fields-container"
                    v-if="isSectionOpen(fIdx, sIdx) && section.questions && section.questions.length"
                  >
                    <div
                      v-for="(question, qIdx) in section.questions"
                      :key="`question-${qIdx}`"
                      class="form-group mb-3"
                    >
                      <label class="fw-medium text-xs text-start d-block mt-3">
                        {{ question.question_text }}
                        <span v-if="question.is_mandatory" class="text-danger fs-5">*</span>
                      </label>

                      <template v-if="question.question_type && question.question_type.question_type === 'short_text'">
                        <input
                          type="text"
                          class="form-control form-control-lg text-xxs bg-white border-1 py-1 rounded-lg"
                          v-model="safe_forms[fIdx][question.section_question_id]"
                          :required="question.is_mandatory"
                        />
                      </template>

                      <template v-else-if="question.question_type && question.question_type.question_type === 'long_text'">
                        <textarea
                          class="form-control form-control-lg text-xxs bg-white border-1 py-1 rounded-lg"
                          rows="3"
                          v-model="safe_forms[fIdx][question.section_question_id]"
                          :required="question.is_mandatory"
                        ></textarea>
                      </template>

                      <template v-else-if="question.question_type && question.question_type.question_type === 'date'">
                        <input
                          type="date"
                          class="form-control form-control-lg text-xxs bg-white border-1 py-1 rounded-lg"
                          v-model="safe_forms[fIdx][question.section_question_id]"
                          :required="question.is_mandatory"
                        />
                      </template>

                      <template v-else-if="question.question_type && question.question_type.question_type === 'single_select'">
                        <template v-if="question.multi_select_choices && question.multi_select_choices.length">
                          <div
                            v-for="choice in question.multi_select_choices"
                            :key="choice.choice"
                            class="form-check"
                          >
                            <input
                              class="form-check-input"
                              type="radio"
                              :name="`question-${fIdx}-${question.id}`"
                              :value="choice.choice"
                              v-model="safe_forms[fIdx][question.section_question_id]"
                            />
                            <label class="form-check-label text-xxs">
                              {{ choice.choice }}
                            </label>
                          </div>
                        </template>
                        <div v-else class="text-danger text-xxs">No choices available</div>
                      </template>

                      <template v-else-if="question.question_type && question.question_type.question_type === 'multi_select'">
                        <template v-if="question.multi_select_choices && question.multi_select_choices.length">
                          <div
                            v-for="choice in question.multi_select_choices"
                            :key="choice.choice"
                            class="form-check"
                          >
                            <input
                              class="form-check-input"
                              type="checkbox"
                              :value="choice.choice"
                              v-model="safe_forms[fIdx][question.section_question_id]"
                            />
                            <label class="form-check-label text-xxs">
                              {{ choice.choice }}
                            </label>
                          </div>
                        </template>
                        <div v-else class="text-danger text-xxs">No choices available</div>
                      </template>

                      <template v-else>
                        <div class="form-control-plaintext text-muted text-xxs">
                          <span v-if="question.question_type">
                            Question type: {{ question.question_type.question_type }}
                          </span>
                          <span v-else>Unknown question type</span>
                          <br />
                          Current value: {{ safe_forms[fIdx][question.section_question_id] }}
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>

              <div class="d-flex justify-content-center mt-4">
                <button
                  class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark px-4"
                  @click="
                    current_form_index === safe_form_config.length - 1
                      ? submitAnswers()
                      : nextForm()
                  "
                >
                  {{ current_form_index === safe_form_config.length - 1 ? 'Submit' : 'Next' }}
                </button>
              </div>
            </div>
          </div>
        </template>

        <div v-else class="text-center py-5">
          <div class="text-muted">No forms available</div>
        </div>
      </div>
    </div>
</template>